export default () => {
  const loadCSS = () => {
    import(/* webpackChunkName: "base-noncritical" */ '@/assets/web/css/base-noncritical.scss');
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadCSS, { timeout: 1500 });
  } else {
    requestAnimationFrame(() => setTimeout(loadCSS, 0));
  }
};
